import {push} from "connected-react-router";
import {VALIDATE_ROUTE} from "../components/Root/routes";

const startOverClient= (userName) => async (dispatch) =>
{
    dispatch(push(VALIDATE_ROUTE + '?userName=' +userName));
};
export default startOverClient;